import { RewardSummary, ResourceRewards } from '@entities/game-resource';
import type { CampaignRewards as Rewards } from '../model/campaign-rewards';

export const CampaignRewards = ({
  rewards,
  earned,
  showCompletionRewards = true,
}: {
  rewards: Rewards;
  earned?: Rewards;
  showCompletionRewards?: boolean;
}) => (
  <>
    <RewardSummary rewards={rewards} earned={earned} />
    {showCompletionRewards && <ResourceRewards rewards={rewards} />}
  </>
);
